<template>
  <div>
    <b-row class="mb-2">
      <b-col cols="12" md="6">
        <b-form-group label="Selecione o Alojamento">
          <v-select v-model="selectedAlojamento" :options="alojamentos" label="descricao" @input="fetchQuartos" />
        </b-form-group>
      </b-col>
      <b-col class="text-right align-self-end pb-1">
        <b-button variant="outline-primary" size="sm" @click="fetchData">
          <feather-icon icon="RefreshCwIcon" class="mr-50" /> Atualizar
        </b-button>
      </b-col>
    </b-row>

    <!-- Grid de Quartos -->
    <b-row v-if="selectedAlojamento">
      <b-col v-for="q in quartos" :key="q.id" cols="12" md="6" lg="4">
        <b-card no-body class="border shadow-none mb-2">
          <b-card-header class="bg-light py-1 d-flex justify-content-between align-items-center">
            <h6 class="mb-0">{{ q.codigo }}</h6>
            <b-badge :variant="getOcupacaoVariant(q)">
              {{ getOcupadosCount(q.id) }}/{{ q.qtoCama }}
            </b-badge>
          </b-card-header>
          <b-card-body class="p-1">
            <div v-if="camasPorQuarto[q.id] && camasPorQuarto[q.id].length > 0">
                <small class="text-muted d-block mb-1">Camas:</small>
                <div class="d-flex flex-wrap">
                  <div v-for="cama in camasPorQuarto[q.id]" :key="cama.id" 
                       class="cama-box p-25 border rounded m-25 text-center cursor-pointer"
                       :class="isCamaOcupada(cama.id) ? 'bg-danger text-white' : 'bg-white text-info'"
                       @click="manageCama(cama)"
                       v-b-tooltip.hover :title="getCamaTooltip(cama)">
                    <feather-icon icon="UserIcon" size="16" />
                  </div>
                </div>
            </div>
            <div v-else class="text-center py-1">
                <p class="small text-muted">Este quarto ainda não possui camas geradas.</p>
                <b-button variant="outline-info" size="sm" @click="gerarCamas(q.id)">
                    Gerar {{ q.qtoCama }} Camas
                </b-button>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-alert v-else variant="info" show>
        Por favor, selecione um alojamento para visualizar a distribuição dos quartos.
    </b-alert>

    <!-- Modal Selecionar Participante -->
    <b-modal id="modal-select-hospede" title="Atribuir Cama" @ok="confirmReserva">
      <p>Selecione o participante para a cama <strong>{{ selectedCama ? selectedCama.etiqueta : '' }}</strong>:</p>
      <v-select v-model="selectedParticipante" :options="participantes" label="registro.nome">
          <template #option="option">
             {{ option.registro.nome }} ({{ option.status }})
          </template>
      </v-select>
      <div v-if="selectedCama && isCamaOcupada(selectedCama.id)" class="mt-2">
        <b-button variant="outline-danger" block size="sm" @click="liberarCama">
          Liberar esta cama
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardHeader, BCardBody, BBadge, BButton, BAlert, VBTooltip } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: { BRow, BCol, BCard, BCardHeader, BCardBody, BBadge, BButton, BAlert, vSelect },
  directives: { 'b-tooltip': VBTooltip },
  props: ['eventoId'],
  data() {
    return {
      alojamentos: [],
      selectedAlojamento: null,
      quartos: [],
      camasPorQuarto: {},
      reservas: [],
      participantes: [],
      selectedCama: null,
      selectedParticipante: null
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const [alRes, partRes, resRes] = await Promise.all([
          this.$http.get('/evento/alojamentos/lista'),
          this.$http.get(`/evento/evento_participantes/evento/${this.eventoId}`),
          this.$http.get(`/evento/reservas`) // TODO: Usar endpoint por evento se disponível
        ])
        this.alojamentos = alRes.data
        this.participantes = partRes.data
        this.reservas = resRes.data.content || resRes.data // Dependendo da paginação
      } catch (e) {
        console.error(e)
      }
    },
    async fetchQuartos() {
      if (!this.selectedAlojamento) return
      try {
        const { data } = await this.$http.get(`/evento/quartos/alojamento/${this.selectedAlojamento.id}`)
        this.quartos = data
        this.camasPorQuarto = {}
        for (const q of this.quartos) {
            this.fetchCamas(q.id)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async fetchCamas(quartoId) {
      try {
        const { data } = await this.$http.get(`/evento/camas/quarto/${quartoId}`)
        this.$set(this.camasPorQuarto, quartoId, data)
      } catch (e) {
        console.error(e)
      }
    },
    getOcupacaoVariant(q) {
      const ocupados = this.getOcupadosCount(q.id)
      if (ocupados === 0) return 'success'
      if (ocupados < q.qtoCama) return 'warning'
      return 'danger'
    },
    getOcupadosCount(quartoId) {
        if (!this.camasPorQuarto[quartoId]) return 0
        return this.camasPorQuarto[quartoId].filter(c => this.isCamaOcupada(c.id)).length
    },
    isCamaOcupada(camaId) {
        return this.reservas.some(r => r.cama.id === camaId)
    },
    getCamaTooltip(cama) {
        const res = this.reservas.find(r => r.cama.id === cama.id)
        return res ? res.participante.registro.nome : cama.etiqueta
    },
    manageCama(cama) {
        this.selectedCama = cama
        const res = this.reservas.find(r => r.cama.id === cama.id)
        this.selectedParticipante = res ? res.participante : null
        this.$bvModal.show('modal-select-hospede')
    },
    async gerarCamas(quartoId) {
        try {
            await this.$http.post(`/evento/quartos/${quartoId}/gerar-camas`)
            this.$toast.success('Camas geradas com sucesso')
            this.fetchCamas(quartoId)
        } catch (e) {
            this.$toast.error('Erro ao gerar camas')
        }
    },
    async confirmReserva() {
        if (!this.selectedParticipante) return
        const payload = {
            participante: { id: this.selectedParticipante.id },
            cama: { id: this.selectedCama.id },
            status: 'RESERVADO'
        }
        try {
            await this.$http.post('/evento/reservas', payload)
            this.$toast.success('Reserva confirmada')
            this.fetchData()
            this.fetchQuartos()
        } catch (e) {
            this.$toast.error('Erro ao salvar reserva')
        }
    },
    async liberarCama() {
        const res = this.reservas.find(r => r.cama.id === this.selectedCama.id)
        if (res) {
            try {
                await this.$http.delete(`/evento/reservas/${res.id}`)
                this.$toast.success('Cama liberada')
                this.$bvModal.hide('modal-select-hospede')
                this.fetchData()
                this.fetchQuartos()
            } catch (e) {
                this.$toast.error('Erro ao liberar cama')
            }
        }
    }
  }
}
</script>

<style scoped>
.cama-box {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.cama-box:hover {
    transform: scale(1.1);
    z-index: 5;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
